<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <div class="summary-popup">
    <form [formGroup]="groupSummaryForm" class="form-wrapper">
      <ion-row>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <div class="form-group form-group-lg no-margin">
            <span class="big-label">{{ CONSTS.LABEL }} </span>
          </div>
          <app-form-date-picker
            [icon]="IMAGES.CALENDAR"
            [customClass]="'report-date-picker'"
            [minDate]="minDate"
            [maxDate]="maxDate"
            formControlName="date"
          ></app-form-date-picker>
        </ion-col>
        <ion-col
          size="12"
          size-sm="6"
          size-md="6"
          size-lg="6"
          size-xl="12"
          class="report-format-container"
        >
          <app-report-format
            [radioButtonValue]="groupSummaryForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
        </ion-col>
      </ion-row>
    </form>
  </div>
</app-modal-frame>

<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="groupSummaryReport && groupSummaryReport.response.groupSummary"
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasTotalRow]="true"
  [hasSingleSubHeaderView]="false"
  [tableFontSize]="'10px'"
  [columnDataFontSize]="'10px'"
>
  @if (groupSummaryReport && groupSummaryReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.GROUP_CODE }}
            {{ groupSummaryReport.response.groupCode }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.GROUP_NAME }}
            {{ groupSummaryReport.response.groupName }}
          </td>
          <td>{{ groupSummaryReport.response.date }}</td>
          <td></td>
        </tr>
      </table>
    </ng-container>
  }
  <ng-container total-row>
    @if (groupSummaryReport && groupSummaryReport.response) {
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">{{ PDF_REPORT.FOOTER.TOTAL }}</td>
          <td class="pdf-total-cell"></td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalStops }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalDeliveryStopsNet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalDeliveryPkgsNet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalPickupStopsNet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalPickupPkgsNet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalMissedPickup }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalMissedDelStop }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalMissedDelPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalSendAgainCod }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalSendAgainPaid }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalNetCod }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalOffload }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalOpen }}
          </td>
          <td class="pdf-total-cell">
            {{ groupSummaryReport.response.totalOther }}
          </td>
        </tr>
      </table>
    }
  </ng-container>
</app-pdf-report-generator>
